import React, { useState, useEffect, useRef } from "react";
import ArrowRight from "assets/images/svg/arrow-right.svg";
import AnimateHeight from "react-animate-height";

const ExpandableTab = ({
    className = "",
    title = "",
    expandTab = false,
    onExpandTabClick = () => {},
    children: Children,
    expandable = true,
    isIndicatorShow = false,
    disable = false,
    rightIcon,
    titleClassName = "",
}) => {
    const [isExpanded, setIsExpanded] = useState(expandTab);

    const ref = useRef(null);

    useEffect(() => {
        if (isExpanded === expandTab) return;
        setIsExpanded(expandTab);
    }, [expandTab]);

    //useEffect(() => {
    // if (closeOnOutsideClick) {
    //     window.addEventListener("mousedown", expandableOutsideClick)
    // }
    // return function (closeOnOutsideClick) {
    //     return function () {
    //         if (closeOnOutsideClick) window.removeEventListener("mousedown", expandableOutsideClick)
    //     }
    // }(closeOnOutsideClick)
    //}, []);

    // const expandableOutsideClick = (event) => {
    //     if (ref.current && !ref.current.contains(event.target)) {
    //         setIsExpanded(false);
    //     }
    // };

    const onTabClick = () => {
        expandable && setIsExpanded(!isExpanded);
        onExpandTabClick();
    };

    return (
        <div
            ref={ref}
            className={`flex column expandable-tabs info-item ${className} ${isExpanded ? "sticky" : ""}`}
            role="button"
        >
            <div className="flex row justify-between headline toggle" onClick={onTabClick}>
                <div>
                    <h5 className={`name my-0 fw-500 ${titleClassName}`}>{title}</h5>
                </div>
                <div className="flex row align-center arrow-container">
                    {typeof rightIcon === "object" ? rightIcon : null}
                    {isIndicatorShow && <div className={"expandable-indicator"} />}
                    {!disable ? <ArrowRight className={`arrow ${isExpanded && "opened"}`} /> : null}
                </div>
            </div>
            <AnimateHeight duration={600} height={isExpanded ? "auto" : 0}>
                <div className={"expanded-content"}>{Children}</div>
            </AnimateHeight>
        </div>
    );
};

export default ExpandableTab;
